export const blue = {
  10: '#F7F9FD',
  20: '#EBF1FA',
  40: '#CFDEF2',
  60: '#9CBDE2',
  80: '#74A2D7',
  100: '#3878C5',
  120: '#2D619F',
  140: '#224977',
};

export const brown = {
  10: '#FCFAF8',
  20: '#F7F2EE',
  40: '#EBDFD6',
  60: '#D5BCAA',
  80: '#C4A188',
  100: '#9A6C4C',
  120: '#77543B',
  140: '#664833',
};

export const green = {
  10: '#FAFEF6',
  20: '#F3FCE8',
  40: '#E3F6CB',
  60: '#C4ED92',
  80: '#AEE567',
  100: '#8ADA25',
  120: '#6FAF1D',
  140: '#538316',
};

export const grey = {
  10: '#F9FAFA',
  20: '#F4F6F6',
  40: '#E9EBED',
  60: '#D7DBDF',
  80: '#C3C9D0',
  100: '#AAB3BB',
  120: '#8E9AA4',
  140: '#687782',
  160: '#5B6770',
  180: '#3B4349',
  200: '#1B1F22',
  220: '#0E1011',
};

export const lime = {
  10: '#FDFEF6',
  20: '#FBFCE8',
  40: '#F1F4CD',
  60: '#E1E797',
  80: '#D4DD6E',
  100: '#C1CE31',
  120: '#9BA527',
  140: '#616718',
};

export const maroon = {
  10: '#FFF5F8',
  20: '#FFE5EE',
  40: '#FFC2D7',
  60: '#FF80AB',
  80: '#FF4C8A',
  100: '#E5004F',
  120: '#B2003D',
  140: '#80002C',
};

export const navy = {
  10: '#F5FCFF',
  20: '#E6F8FF',
  40: '#C2EEFF',
  60: '#80DBFF',
  80: '#4CCDFF',
  100: '#00B8FF',
  120: '#0093CC',
  140: '#006E99',
};

export const olive = {
  10: '#FAFCF8',
  20: '#F3F7ED',
  40: '#E2EBD6',
  60: '#C2D6A8',
  80: '#A9C686',
  100: '#789D4A',
  120: '#5D7939',
  140: '#425729',
};

export const orange = {
  10: '#FFFAF5',
  20: '#FFF2E5',
  40: '#FCDFC5',
  60: '#FABD85',
  80: '#F8A154',
  100: '#F68723',
  120: '#DC6D0A',
  140: '#924907',
};

export const pink = {
  10: '#FEF6FA',
  20: '#FCE8F2',
  40: '#F8C9DF',
  60: '#F18DBC',
  80: '#EB60A1',
  100: '#E11C78',
  120: '#B61661',
  140: '#881149',
};

export const purple = {
  10: '#FDF6FC',
  20: '#FBE9F9',
  40: '#F6CBF0',
  60: '#EB93E0',
  80: '#E468D3',
  100: '#C223AD',
  120: '#821773',
  140: '#6C1460',
};

export const red = {
  10: '#FEF6F6',
  20: '#FCE9E8',
  40: '#F8CCC9',
  60: '#F0948E',
  80: '#EB6A61',
  100: '#E22B1D',
  120: '#B52217',
  140: '#881A11',
};

export const teal = {
  10: '#F5FEFF',
  20: '#E5FDFF',
  40: '#C2FAFF',
  60: '#80F4FF',
  80: '#4CF0FF',
  100: '#00D2E5',
  120: '#00A4B2',
  140: '#007B80',
};

export const turquoise = {
  10: '#F7FDFC',
  20: '#EBFAF8',
  40: '#CDF4EE',
  60: '#96E8DB',
  80: '#6CDFCD',
  100: '#28BDA5',
  120: '#22A08B',
  140: '#16695B',
};

export const violet = {
  10: '#F9F7FD',
  20: '#EFEBF9',
  40: '#D8D0F0',
  60: '#AF9EE1',
  80: '#8E77D5',
  100: '#5E3DC2',
  120: '#4B319B',
  140: '#382475',
};

export const yellow = {
  10: '#FFFCF5',
  20: '#FFF8E5',
  40: '#FFEEC2',
  60: '#FFDB80',
  80: '#FFCC4C',
  100: '#FFB700',
  120: '#D69A00',
  140: '#805B00',
};

export const common = {
  black: '#000',
  dark: grey[200],
  white: '#fff',
  light: grey[20],
};

export const colors = {
  blue,
  brown,
  green,
  red,
  orange,
  lime,
  teal,
  turquoise,
  yellow,
  violet,
  purple,
  pink,
  navy,
  olive,
  common,
};

export type Color = keyof typeof colors;

export default colors;
